require('./brokerConvenienceMiFIDTestStep0.scss')

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const { connect } = require('react-redux');

// @components
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');
const { OKLink } = require('commonsComponents/OKLink');
const { OKMessage } = require('commonsComponents/OKMessage');
const { OKButton } = require('components/commons/OKButton/OKButton');

// @constants
const { FIRST_STEP } = require('constants/index');

// @helpers
const { FormattedText, formatText } = require('core/i18n').i18n;

// @actions
const BrokerConvenienceMiFIDTestStep0Action = require('mifid/actions/brokerConvenienceMiFIDTest/brokerConvenienceMiFIDTestStep0');

class BrokerConvenienceMiFIDTestStep0 extends React.Component {


    stepHasValidationError() {
        const { immBrokerConvenienceMiFIDTest } = this.props;
        const immZeroStep = immBrokerConvenienceMiFIDTest.get('steps').get(FIRST_STEP);
        return !immZeroStep.get('valid') && immZeroStep.get('validated');
    }

    buildValidationError() {
        let error = this.stepHasValidationError();
        let errorSection;
        if (error) {
            errorSection = (
                <div className="broker-convenience-mifid-test-wizard__error-message">
                    <FormattedText value="consultMiFID-validationGenericError"/>
                </div>
            );
        }
        return errorSection;
    }

    buildRadioButtonSection(){
        const { immBrokerConvenienceMiFIDTest, isConsulting, onChangeUpdateReason } = this.props;
        const immZeroStep = immBrokerConvenienceMiFIDTest.get('steps').get(FIRST_STEP);
        const updateReasonAnswer = immZeroStep.getIn(['updateReason', 'answer']);
        const answers = immZeroStep.getIn(['updateReason', 'answers']).map((immAnswer) => {
            return (
                <RadioButton
                    key={immAnswer.get('id')}
                    disabled={isConsulting}
                    label={immAnswer.get('description')}
                    value={immAnswer.get('id')}
                />
            );
        });
        return(
            <div className="broker-convenience-mifid-test-step-0__test-section">
                <h5 className="broker-convenience-mifid-test-step-0__subtitle">
                    {immZeroStep.getIn(['updateReason', 'question'])}
                </h5>
                <RadioButtonGroup
                    name="updateReason"
                    idPrefix="updateReasonPrefix"
                    selectedValue={updateReasonAnswer}
                    onChange={onChangeUpdateReason}
                >
                    {answers}
                </RadioButtonGroup>
                {this.buildValidationError()}
            </div>
        )
    }

    render(){
        const { actions, cancelButton, isConsulting, nextButton } = this.props;
        const radioButtonSection = this.buildRadioButtonSection();
        const link = formatText('disclaimerPersonalInfo-mifidGdprDisclaimerLinkUrl');
        return (
            <WizardStep
                actions={actions}
                goBackButton={isConsulting}
                cancelButton={cancelButton}
                nextButton={nextButton}
                position="first"
            >
                <h4 className="broker-convenience-mifid-test-step-0__title">
                    <FormattedText value="broker-convenienceMifidTestConvenienceStep0Title" />
                </h4>
                {radioButtonSection}
                <OKMessage type="informative">
                    <FormattedText value="disclaimerPersonalInfo-mifidGdprDisclaimerText" />
                    &nbsp;
                    <OKLink to={link} target="_blank" modifier="emphasize">
                        <FormattedText value="disclaimerPersonalInfo-mifidGdprDisclaimerLinkText" />
                    </OKLink>
                </OKMessage>
            </WizardStep>
        );
    }
}

BrokerConvenienceMiFIDTestStep0.propTypes = {
    actions: PropTypes.object.isRequired,
    cancelButton: PropTypes.bool,
    immBrokerConvenienceMiFIDTest: PropTypes.object.isRequired,
    isConsulting: PropTypes.bool,
    nextButton: PropTypes.bool,
}

BrokerConvenienceMiFIDTestStep0.defaultProps = {
    cancelButton: true,
    isConsulting: false,
    nextButton: true,
};

module.exports.constructor = BrokerConvenienceMiFIDTestStep0;
module.exports.BrokerConvenienceMiFIDTestStep0 = connect(
    (state) => ({ immBrokerConvenienceMiFIDTest: state.brokerConvenienceMiFIDTest }),
    {
        onChangeUpdateReason: BrokerConvenienceMiFIDTestStep0Action.changeUpdateReason,
    }
) (BrokerConvenienceMiFIDTestStep0);
